module.exports = __webpack_public_path__ + "static/media/w_knight.2922cef7.png";